import { getProperties } from '../services/vu'

const appProperties = {
  loaded: false
}
export const loadProperties = () => {
  return getProperties()
    .then(properties => {
      appProperties.loaded = true
      Object.keys(properties).forEach(function(key) {
        appProperties[key] = properties[key]
      })
      Object.freeze(appProperties)
      return appProperties.loaded
    })
    .catch(error => {
      throw error
    })
}

export const getProperty = (property = '') => {
  if (!appProperties['loaded']) {
    getProperties().then(properties => {
      appProperties.loaded = true
      Object.keys(properties).forEach(function(key) {
        appProperties[key] = properties[key]
      })
      Object.freeze(appProperties)
      return appProperties[property]
    })
  }
  return appProperties[property]
}
